import {API_BASE} from '../apiConfig';
import {setPlayerAuth} from '../../redux/actions';

/**
 * Отметить в профиле, что игрок закрыл вступительные слайды. Метка живет на
 * сервере, а не только в localStorage: человек не должен увидеть питч заново с
 * другого устройства.
 *
 * Ошибка сети сюда не пробрасывается: слайды в этот момент уже закрываются, и
 * ронять этот переход из-за метки нельзя — в худшем случае колода покажется
 * еще раз (локальная отметка все равно поставлена).
 */
export const markIntroSlidesSeen = async (dispatch, auth) => {
  try {
    const res = await fetch(`${API_BASE}/users/me/intro-slides/seen`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const data = await res.json();
    if (data.user) {
      dispatch(setPlayerAuth({...auth, ...data.user}));
    }
  } catch (error) {
    console.error('[IntroSlides] Не удалось сохранить метку показа', error);
  }
};
